import axios from "axios";
import store from "../../store/index";
import SiteAffectedDetailsModal from "./SiteAffectedDetailsModal.vue";

export default {
  name: "DataSignalOverview",
  data() {
    return {
      head: {},
      idToken: "",
      DataSignalSummaryForList: [],
      transformedTechniqueData: [],
      baseapi: process.env.VUE_APP_Service_URL,
      criticalSignalSeries: [],
      criticalSignalOptions: {},
      criticalSignalTrendSeries: [],
      criticalSignalTrendOptions: {},
      showSiteAffectedModal: false,
      showSiteNotAffectedModal: false,
      selectedTechniqueName: "",
      siteAffectedDetails: [],
      siteNotAffectedDetails: [],
      dataSignalSiteSummary: []
    };
  },
  components: {
    SiteAffectedDetailsModal
  },
  mounted() {
    this.idToken = store.getters.getIdToken;
    this.head = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    this.getDataSignalStudySiteSummary();
    this.getCriticalDataSignalChart();
  },
  methods: {
    async getDataSignalStudySiteSummary() {
      const idtoken = store.getters.getIdToken;
      this.studyId = store.getters.getStudyIs;

      // optional loader flag
      this.dataSignalLoading = true;

      try {
        const url =
          this.baseapi +
          "/forms/rbqm/getdatasignalstudysitesummary?studyId=" +
          encodeURIComponent(this.studyId);

        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json"
          }
        });

        // API returns array directly
        const entities = Array.isArray(res.data) ? res.data : [];
        // store raw response (useful for drilldown)
        this.dataSignalSiteSummary = entities;
        this.DataSignalSummaryForList = entities;
        this.transformedTechniqueData = this.transformDataByTechnique(entities);
        console.log("DataSignalSummaryForList", this.DataSignalSummaryForList);
        console.log("transformedTechniqueData", this.transformedTechniqueData);        
        const categories = [];
        const values = [];

        for (let i = 0; i < entities.length; i++) {
          const it = entities[i];

          // safe siteCode extraction
          let siteCode = "";
          if (it && it.siteCode !== undefined && it.siteCode !== null) {
            siteCode = String(it.siteCode).trim();
          }

          if (!siteCode) continue;

          // safe number extraction
          let y = 0;
          if (it && it.criticalSignalsCount !== undefined && it.criticalSignalsCount !== null) {
            const num = Number(it.criticalSignalsCount);
            y = isFinite(num) ? num : 0;
          }

          categories.push(siteCode);
          values.push(y);
        }

        // Apex series
        this.criticalSignalSeries = [
          {
            name: "Critical Signals",
            data: values
          }
        ];

        // Apex options
        this.criticalSignalOptions = {
          chart: {
            type: "bar",
            height: 350,
            toolbar: { show: false }
          },
          plotOptions: {
            bar: {
              columnWidth: "55%",
              borderRadius: 4
            }
          },
          dataLabels: {
            enabled: true
          },
          xaxis: {
            categories: categories,
            title: { text: "Site Code" },
            labels: {
              rotate: -45,
              trim: true
            }
          },
          yaxis: {
            title: { text: "Critical Signals Count" },
            min: 0
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + " signals";
              }
            }
          },
          noData: {
            text: "No data available"
          }
        };

        // default site (first available)
        this.defaultsite = categories.length > 0 ? categories[0] : "";

      } catch (err) {
        console.log("getDataSignalStudySiteSummary error:", err);

        // reset state on error
        this.dataSignalSiteSummary = [];
        this.criticalSignalSeries = [];
        this.criticalSignalOptions = {
          noData: { text: "Failed to load data" }
        };
        this.defaultsite = "";
      } finally {
        this.dataSignalLoading = false;
      }
    },
    async getCriticalDataSignalChart() {
      const idtoken = store.getters.getIdToken;
      this.studyId = store.getters.getStudyIs;

      this.dataSignalLoading = true;

      try {
        const url =
          this.baseapi +
          "/forms/rbqm/getdatasignalstudysitesummary?studyId=" +
          encodeURIComponent(this.studyId)+"&flagged=true";

        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json"
          }
        });

        // API returns array directly
        const entities = Array.isArray(res.data) ? res.data : [];
        this.buildCriticalSignalTrendChart(entities);
  

      } catch (err) {
        console.log("getDataSignalStudySiteSummary error:", err);

      } 
    },
   buildCriticalSignalTrendChart(entities) {
  const rows = [];

  for (let i = 0; i < entities.length; i++) {
    const it = entities[i];
    if (!it || !it.runDate) continue;

    const ts = new Date(it.runDate).getTime();
    if (!isFinite(ts)) continue;

    let y = 0;
    if (it.criticalSignalsCount !== undefined && it.criticalSignalsCount !== null) {
      const num = Number(it.criticalSignalsCount);
      y = isFinite(num) ? num : 0;
    }

    rows.push({
      ts: ts,
      iso: new Date(ts).toISOString(),
      y: y
    });
  }


  rows.sort(function (a, b) {
    return a.ts - b.ts;
  });

  const categories = [];
  const values = [];

  for (let j = 0; j < rows.length; j++) {
    categories.push(rows[j].iso);
    values.push(rows[j].y);
  }

  this.criticalSignalTrendSeries = [
    {
      name: "Critical Signals",
      data: values
    }
  ];

  this.criticalSignalTrendOptions = {
    chart: {
      type: "line",
      height: 350,
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    stroke: { curve: "smooth", width: 3 },
    markers: { size: 4 },
    xaxis: {
      type: "datetime",
      categories: categories,    
      title: { text: "Run Date" },
      labels: { datetimeUTC: false }
    },
    yaxis: {
      min: 0,
      title: { text: "Critical Signals Count" }
    },
    tooltip: {
      x: { format: "dd MMM yyyy HH:mm" },
      y: {
        formatter: function (val) {
          return val + " signals";
        }
      }
    },
    noData: { text: "No trend data" }
  };
},

    transformDataByTechnique(entities) {
      // Group data by techniqueName
      const techniqueMap = {};

      for (let i = 0; i < entities.length; i++) {
        const site = entities[i];
        if (!site || !site.criticalDataSignal) continue;

        // Iterate through criticalDataSignal array
        for (let j = 0; j < site.criticalDataSignal.length; j++) {
          const signal = site.criticalDataSignal[j];
          const isFlagged = signal.isFlagged === "true" || signal.isFlagged === true;

          if (!signal.flagTypes) continue;

          // Iterate through flagTypes array
          for (let k = 0; k < signal.flagTypes.length; k++) {
            const flagType = signal.flagTypes[k];
            const techniqueName = flagType.techniqueName;

            if (!techniqueName) continue;

            // Initialize technique entry if not exists
            if (!techniqueMap[techniqueName]) {
              techniqueMap[techniqueName] = {
                techniqueName: techniqueName,
                techniqueCode: flagType.techniqueCode,
                siteAffected: 0,
                siteNotAffected: 0
              };
            }

            // Count affected/not affected
            if (isFlagged) {
              techniqueMap[techniqueName].siteAffected++;
            } else {
              techniqueMap[techniqueName].siteNotAffected++;
            }
          }
        }
      }

      // Convert map to array and sort alphabetically by techniqueName
      return Object.values(techniqueMap).sort((a, b) => {
        return a.techniqueName.localeCompare(b.techniqueName);
      });
    },

    riskClass(score) {
      if (score >= 20) return "risk-high";
      if (score >= 10) return "risk-medium";
      return "risk-low";
    },

    openSiteAffectedModal(techniqueName) {
      this.selectedTechniqueName = techniqueName;
      this.siteAffectedDetails = this.getSiteAffectedDetails(techniqueName);
      this.showSiteAffectedModal = true;
    },

    closeSiteAffectedModal() {
      this.showSiteAffectedModal = false;
      this.selectedTechniqueName = "";
      this.siteAffectedDetails = [];
    },

    openSiteNotAffectedModal(techniqueName) {
      this.selectedTechniqueName = techniqueName;
      this.siteNotAffectedDetails = this.getSiteNotAffectedDetails(techniqueName);
      this.showSiteNotAffectedModal = true;
    },

    closeSiteNotAffectedModal() {
      this.showSiteNotAffectedModal = false;
      this.selectedTechniqueName = "";
      this.siteNotAffectedDetails = [];
    },

    getSiteAffectedDetails(techniqueName) {
      const details = [];

      // Iterate through raw data to extract affected sites
      for (let i = 0; i < this.dataSignalSiteSummary.length; i++) {
        const site = this.dataSignalSiteSummary[i];
        if (!site || !site.criticalDataSignal) continue;

        // Iterate through criticalDataSignal array
        for (let j = 0; j < site.criticalDataSignal.length; j++) {
          const signal = site.criticalDataSignal[j];
          const isFlagged = signal.isFlagged === "true" || signal.isFlagged === true;

          if (!isFlagged || !signal.flagTypes) continue;

          // Iterate through flagTypes array
          for (let k = 0; k < signal.flagTypes.length; k++) {
            const flagType = signal.flagTypes[k];

            // Only include entries that match the selected technique
            if (flagType.techniqueName === techniqueName) {
              // Join fieldName array into comma-separated string
              const fieldNameStr = Array.isArray(flagType.fieldName) 
                ? flagType.fieldName.join(", ") 
                : (flagType.fieldName || "");

              details.push({
                siteCode: site.siteCode || "",
                flagType: signal.flagType || "",
                fieldName: fieldNameStr
              });
            }
          }
        }
      }

      return details;
    },

    getSiteNotAffectedDetails(techniqueName) {
      const details = [];

      // Iterate through raw data to extract not affected sites
      for (let i = 0; i < this.dataSignalSiteSummary.length; i++) {
        const site = this.dataSignalSiteSummary[i];
        if (!site || !site.criticalDataSignal) continue;

        // Iterate through criticalDataSignal array
        for (let j = 0; j < site.criticalDataSignal.length; j++) {
          const signal = site.criticalDataSignal[j];
          const isFlagged = signal.isFlagged === "true" || signal.isFlagged === true;

          // Only process non-flagged entries for "Site Not Affected"
          if (isFlagged || !signal.flagTypes) continue;

          // Iterate through flagTypes array
          for (let k = 0; k < signal.flagTypes.length; k++) {
            const flagType = signal.flagTypes[k];

            // Only include entries that match the selected technique
            if (flagType.techniqueName === techniqueName) {
              // Join fieldName array into comma-separated string
              const fieldNameStr = Array.isArray(flagType.fieldName) 
                ? flagType.fieldName.join(", ") 
                : (flagType.fieldName || "");

              details.push({
                siteCode: site.siteCode || "",
                flagType: signal.flagType || "",
                fieldName: fieldNameStr
              });
            }
          }
        }
      }

      return details;
    }
  }
};